import React from "react";

import { Button, Col, Row } from "react-bootstrap";

import { LeftArrowIcon } from "@assets/icons";

import { IconButton } from "../IconButton";

interface FormNavigationButtonsProps<TFormData> {
  isInsertMode: boolean;
  onSubmit: (data: TFormData) => void;
  onCancel?: () => void;
  handleSubmit: (callback: (data: TFormData) => void) => (e?: React.BaseSyntheticEvent) => Promise<void>;
  showPreviousButton?: boolean;
  submitRef?: React.RefObject<HTMLButtonElement>;
}

const FormNavigationButtons = <TFormData,>({
  isInsertMode,
  onSubmit,
  onCancel,
  handleSubmit,
  showPreviousButton = true,
  submitRef,
}: FormNavigationButtonsProps<TFormData>) => {
  return (
    <>
      <Row>
        <Col className="d-flex justify-content-center mb-2 mt-3">
          <Button ref={submitRef} onClick={handleSubmit(onSubmit)} style={{ display: isInsertMode ? "block" : "none" }}>
            Next
          </Button>
        </Col>
      </Row>
      {onCancel && isInsertMode && showPreviousButton && (
        <Row>
          <Col className="mt-4 d-flex justify-content-center">
            <IconButton variant="tertiary" text="Previous" src={LeftArrowIcon} onClick={onCancel}></IconButton>
          </Col>
        </Row>
      )}
    </>
  );
};

export default FormNavigationButtons;
